import { Directive, ElementRef, HostListener, Input, Output, EventEmitter, ViewChild  } from '@angular/core';

@Directive({
  selector: '[userIdInputMask]'
})
export class UserIdInputMaskDirective {

  constructor(private el: ElementRef) { 
  }

  originalEntry = '';

  maskedInputView: any;
  maskedInputValue: any;

  @HostListener('blur', ["$event.target.value"]) onblur(value) {
    this.originalEntry = this.maskedInputValue.value;
    this.applyMask();
    this.maskedInputView.style.display = 'block';
    this.maskedInputValue.style.color = 'transparent';
  }

  @HostListener('focus') onfocus() {
    if(this.maskedInputValue.value){
    	this.removeMask();
    }
    this.maskedInputView.style.display = 'none';
    this.maskedInputValue.style.color = '#000';
  }

  private removeMask() {
    if(this.originalEntry) {
      this.maskedInputView.textContent = this.originalEntry;
    }
  }

  private applyMask() {
    const maskedValue = this.maskMiddle();

    const inputValue = this.maskedInputValue.value;
    
    if (inputValue && inputValue !== null && inputValue !== '') {
      try { 
        this.maskedInputView.textContent = maskedValue;
      }
      catch (e) {
        this.maskedInputView.textContent = inputValue;
      }
    } else {
      this.maskedInputView.textContent = '';
    }
    this.maskedInputValue.setAttribute('masked', true);
    this.maskedInputValue.style.color = 'transparent';
  }

  maskMiddle() {
    let inputValue = this.maskedInputValue.value;
    let length = inputValue.length;
    if(length >= 3) {
      if(length <= 6) {
        if(length = 3) {
          let hide = inputValue.slice(1, -1).replace(/./g, '*');
          let maskedValue = inputValue.slice(0, 1) + hide + inputValue.slice(-1);
          return maskedValue;
        }
        let showFirst = inputValue.slice(0, 1);
        let showLast = inputValue.slice(-1);
        let hide = inputValue.slice(1, -1).replace(/./g, '*');
        let maskedValue = showFirst + hide + showLast;
        return maskedValue;
      } else {
        let showFirst = inputValue.slice(0, 2);
        let showLast = inputValue.slice(-2);
        let hide = inputValue.slice(2, -2).replace(/./g, '*');
        let maskedValue = showFirst + hide + showLast;
        return maskedValue;
      }
    } else {
      return inputValue;
    }
  }

  ngAfterViewInit() {
    this.maskedInputValue = this.el.nativeElement;
    this.maskedInputView = this.maskedInputValue.parentElement.querySelector('.masked-input-view');;
    this.originalEntry = this.maskedInputValue.value;
    this.applyMask();
  }
}
